import NavBar from 'components/NavBar';
import Hero from 'components/Hero';
import About from 'components/About';
import Focus from 'components/Focus';
import Connect from 'components/Connect';

import './App.css';

function App() {
  return (
    <div className="App">
      <NavBar />
      <main>
        <Hero />
        <About />
        <Focus />
        <Connect />
      </main>
    </div>
  );
}

export default App;
